import type { SelectDesignTokens } from '@primeuix/themes/types/select';

/**
 * Select component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/select/index.ts
 *
 * Component documentation:
 * https://primeng.org/select
 */
export const selectComponentTokens: Partial<SelectDesignTokens> = {
  optionGroup: {
    color: '{select.option.color}',
  },
};
